import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import AdminLayout from "./components/AdminLayout";
import HomePage from "./pages/HomePage";
import QuotePage from "./pages/QuotePage";
import QuoteSuccessPage from "./pages/QuoteSuccessPage"; // ✅ NEW
import AdminLoginPage from "./pages/AdminLoginPage";
import DashboardPage from "./pages/DashboardPage";
import UsersPage from "./pages/UsersPage";
import ChangePasswordPage from "./pages/ChangePasswordPage";
import QuoteBuilderPage from "./pages/QuoteBuilderPage";
import { Toaster } from "./components/ui/sonner";
import InstantQuotePage from './pages/InstantQuotePage';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/quote" element={<QuotePage />} />
	  <Route path="/instantquote" element={<InstantQuotePage />} />
          <Route path="/quote-success" element={<QuoteSuccessPage />} /> {/* ✅ NEW */}
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* Admin routes with sidebar layout */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="quote-builder" element={<QuoteBuilderPage />} />
            <Route path="change-password" element={<ChangePasswordPage />} />
            <Route index element={<Navigate to="dashboard" replace />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;